import configurationSetPliIntervalTypes from '@/constants/configuration-set-pli-interval-types.js'

const SECONDS_PER_MINUTE = 60

/**
 * The PLI interval values a configuration set may hold. These must stay in step
 * with the `pli_interval_value` rules in app/Http/Requests/ConfigurationSetRequest.php.
 */
export const pliIntervalTimeValues = [5, 15, 30, 60, 90, 120, 150, 180, 300, 600, 900, 1800]
export const pliIntervalDistanceValues = [25, 50, 75, 100, 250, 500, 1000]

function formatUnit(unit, value) {
    const plural = value === 1 ? unit : `${unit}s`
    return plural.charAt(0).toUpperCase() + plural.slice(1)
}

function timeInterval(seconds) {
    if (seconds < SECONDS_PER_MINUTE) {
        return {
            value: seconds.toString(),
            unit: formatUnit('second', seconds),
        }
    }

    const minutes = seconds / SECONDS_PER_MINUTE

    return {
        value: minutes % 1 === 0 ? minutes.toString() : minutes.toFixed(1),
        unit: formatUnit('minute', minutes),
    }
}

function distanceInterval(meters) {
    return {
        value: meters.toString(),
        unit: formatUnit('meter', meters),
    }
}

/**
 * Format a PLI interval for display, converting times of a minute or longer
 * into minutes: `{ value: '2.5', unit: 'Minutes', label: '2.5 Minutes' }`.
 *
 * The label holds no leading "Every", so a caller decides whether to use one.
 * Returns null when there is nothing to show, which lets a caller pick its own
 * empty state.
 */
export function formatPliInterval(type, value) {
    if (!value) {
        return null
    }

    let interval = null

    switch (type) {
        case configurationSetPliIntervalTypes.TIME:
            interval = timeInterval(value)
            break

        case configurationSetPliIntervalTypes.DISTANCE:
            interval = distanceInterval(value)
            break

        default:
            return null
    }

    return {
        ...interval,
        label: `${interval.value} ${interval.unit}`,
    }
}
